var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-panels",class:_vm.classes},[_c('icon-button',{staticClass:"view-panels-close",attrs:{"icon":"cross","callback":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"view-panels-content"},[_c('div',{staticClass:"view-panels-content-relative"},[_c('fade',[_c(_vm.component,{key:_vm.key,tag:"component"})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"view-panels-overlay",on:{"click":_vm.onOverlayClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efff6e8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Panels.vue
// module id = 311
// module chunks = 0